export const destinations1 = [
  { id: 1, city: "Hawai", properties: "12,683",region:'north_america' },
  { id: 2, city: "Istanbul", properties: "12,683",region:'europe' },
  { id: 3, city: "San Diego", properties: "12,683",region:'north_america' },
  { id: 4, city: "Phuket", properties: "12,683",region:'asia' },
  { id: 5, city: "Reykjavik", properties: "12,683",region:'europe' },
  { id: 6, city: "Santorini", properties: "12,683",region:'europe' },
  { id: 7, city: "Los Angeles", properties: "12,683",region:'north_america' },
  { id: 8, city: "Florence", properties: "12,683",region:'europe' },
  { id: 9, city: "Mykonos", properties: "12,683",region:'europe' },
  { id: 10, city: "Paris", properties: "12,683",region:'europe' },
  { id: 11, city: "Dubai", properties: "12,683",region:'asia' },
  { id: 12, city: "Krakow", properties: "12,683",region:'europe' },
  { id: 13, city: "Jersey", properties: "12,683",region:'north_america' },
  { id: 14, city: "Prag", properties: "12,683",region:'europe' },
  { id: 15, city: "Amsterdam", properties: "12,683",region:'europe' },
  { id: 16, city: "İbiza", properties: "12,683",region:'europe' },
  { id: 17, city: "Boston", properties: "12,683",region:'north_america' },
  { id: 18, city: "Florence", properties: "12,683",region:'europe' },
  { id: 19, city: "Mykonos", properties: "12,683",region:'europe' },
  { id: 20, city: "London", properties: "12,683",region:'europe' },
];

export const destinations2 = [
  {
    id: 1,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "New York",
    img: "/img/destinations/1/1.png",
  },
  {
    id: 2,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "London",
    img: "/img/destinations/1/2.png",
  },
  {
    id: 3,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "Barcelona",
    img: "/img/destinations/1/3.png",
  },
  {
    id: 4,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "Sydney",
    img: "/img/destinations/1/4.png",
  },
  {
    id: 5,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "Rome",
    img: "/img/destinations/1/5.png",
  },
  {
    id: 6,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "New York",
    img: "/img/destinations/1/1.png",
  },
  {
    id: 7,
    hoverText: "14 Hotel - 22 Cars - 18 Tours - 95 Activity",
    city: "London",
    img: "/img/destinations/1/2.png",
  },
];

export const destinations3 = [
  {
    id: 1,
    img: "/img/destinations/1/1.png",
    title: "United Kingdom",
    travellers: "147,681",
    delayAnimation: "0",
  },
  {
    id: 2,
    img: "/img/destinations/1/2.png",
    title: "Italy",
    travellers: "147,681",
    delayAnimation: "100",
  },
  {
    id: 3,
    img: "/img/destinations/1/3.png",
    title: "France",
    travellers: "147,681",
    delayAnimation: "200",
  },
  {
    id: 4,
    img: "/img/destinations/1/4.png",
    title: "Turkey",
    travellers: "147,681",
    delayAnimation: "300",
  },
  {
    id: 5,
    img: "/img/destinations/1/5.png",
    title: "Spain",
    travellers: "147,681",
    delayAnimation: "400",
  },
  {
    id: 6,
    img: "/img/destinations/1/1.png",
    title: "United Kingdom",
    travellers: "147,681",
    delayAnimation: "500",
  },
  {
    id: 7,
    img: "/img/destinations/1/2.png",
    title: "Italy",
    travellers: "147,681",
    delayAnimation: "600",
  },
  {
    id: 8,
    img: "/img/destinations/1/3.png",
    title: "France",
    travellers: "147,681",
    delayAnimation: "700",
  },
];

export const destinations4 = [
  {
    id: 1,
    img: "/img/destinations/3/1.png",
    location: "London, UK",
    properties: "4,090",
    delayAnimation: "0",
  },
  {
    id: 2,
    img: "/img/destinations/3/2.png",
    location: "Edinburg, UK",
    properties: "4,090",
    delayAnimation: "100",
  },
  {
    id: 3,
    img: "/img/destinations/3/3.png",
    location: "France",
    properties: "4,090",
    delayAnimation: "200",
  },
  {
    id: 4,
    img: "/img/destinations/3/4.png",
    location: "Turkey",
    properties: "4,090",
    delayAnimation: "300",
  },
  {
    id: 5,
    img: "/img/destinations/3/5.png",
    location: "Spain",
    properties: "4,090",
    delayAnimation: "400",
  },
  {
    id: 6,
    img: "/img/destinations/3/1.png",
    location: "United Kingdom",
    properties: "4,090",
    delayAnimation: "500",
  },
  {
    id: 7,
    img: "/img/destinations/3/2.png",
    location: "Italy",
    properties: "4,090",
    delayAnimation: "600",
  },
  {
    id: 8,
    img: "/img/destinations/3/3.png",
    location: "France",
    properties: "4,090",
    delayAnimation: "700",
  },
  {
    id: 9,
    img: "/img/destinations/3/1.png",
    location: "London, UK",
    properties: "4,090",
    delayAnimation: "800",
  },
  {
    id: 10,
    img: "/img/destinations/3/2.png",
    location: "Edinburg, UK",
    properties: "4,090",
    delayAnimation: "900",
  },
];

export const destinations5 = [
  {
    id: 1,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/2/1.png",
    name: "los angeles",
    numberOfProperties: "1714",
    delayAnimation: "200",
  },
  {
    id: 2,
    colClass: "col-xl-6 col-md-4 col-sm-6",
    img: "/img/destinations/2/2.png",
    name: "london",
    numberOfProperties: "1714",
    delayAnimation: "400",
  },
  {
    id: 3,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/2/3.png",
    name: "reykjavik",
    numberOfProperties: "1714",
    delayAnimation: "600",
  },
  {
    id: 4,
    colClass: "col-xl-6 col-md-4 col-sm-6",
    img: "/img/destinations/2/4.png",
    name: "paris",
    numberOfProperties: "1714",
    delayAnimation: "200",
  },
  {
    id: 5,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/2/5.png",
    name: "amsterdam",
    numberOfProperties: "1714",
    delayAnimation: "400",
  },
  {
    id: 6,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/2/6.png",
    name: "istanbul",
    numberOfProperties: "1714",
    delayAnimation: "600",
  },
];

export const destinations6 = [
  {
    id: 1,
    img: "/img/cities/1/1.png",
    location: "Miami",
    properties: "4,090",
    delayAnim: "0",
  },
  {
    id: 2,
    img: "/img/cities/1/2.png",
    location: "Roma",
    properties: "4,090",
    delayAnim: "100",
  },
  {
    id: 3,
    img: "/img/cities/1/3.png",
    location: "New Delhi",
    properties: "4,090",
    delayAnim: "200",
  },
  {
    id: 4,
    img: "/img/cities/1/4.png",
    location: "London",
    properties: "4,090",
    delayAnim: "300",
  },
  {
    id: 5,
    img: "/img/cities/1/5.png",
    location: "Amsterdam",
    properties: "4,090",
    delayAnim: "400",
  },
  {
    id: 6,
    img: "/img/cities/1/6.png",
    location: "Berlin",
    properties: "4,090",
    delayAnim: "500",
  },
  {
    id: 7,
    img: "/img/cities/1/7.png",
    location: "Paris",
    properties: "4,090",
    delayAnim: "600",
  },
  {
    id: 8,
    img: "/img/cities/1/8.png",
    location: "New Zealand",
    properties: "4,090",
    delayAnim: "700",
  },
];

export const destinations7 = [
  {
    id: 1,
    colClass: "col-xl-6 col-md-4 col-sm-6",
    img: "/img/destinations/4/1.png",
    name: "Paris",
    numberOfProperties: "1714",
    delayAnimation: "100",
  },
  {
    id: 2,
    colClass: "col-xl-6 col-md-4 col-sm-6",
    img: "/img/destinations/4/2.png",
    name: "London",
    numberOfProperties: "1714",
    delayAnimation: "200",
  },
  {
    id: 3,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/4/3.png",
    name: "Los Angeles",
    numberOfProperties: "1714",
    delayAnimation: "300",
  },
  {
    id: 4,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/4/4.png",
    name: "Amsterdam",
    numberOfProperties: "1714",
    delayAnimation: "400",
  },
  {
    id: 5,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/4/5.png",
    name: "Istanbul",
    numberOfProperties: "1714",
    delayAnimation: "500",
  },
  {
    id: 6,
    colClass: "col-xl-3 col-md-4 col-sm-6",
    img: "/img/destinations/4/6.png",
    name: "Raykjavik",
    numberOfProperties: "1714",
    delayAnimation: "600",
  },
];

export const destinations8 = [
  {
    id: 1,
    img: "/img/destinations/5/1.png",
    location: "Paris",
    price: "29.52",
    delayAnimation: "100",
  },
  {
    id: 2,
    img: "/img/destinations/5/2.png",
    location: "London",
    price: "53.52",
    delayAnimation: "200",
  },
  {
    id: 3,
    img: "/img/destinations/5/3.png",
    location: "Los Angeles",
    price: "35.52",
    delayAnimation: "300",
  },
  {
    id: 4,
    img: "/img/destinations/5/4.png",
    location: "Amsterdam",
    price: "29.52",
    delayAnimation: "400",
  },
  {
    id: 5,
    img: "/img/destinations/5/5.png",
    location: "Istanbul",
    price: "27.52",
    delayAnimation: "500",
  },
  {
    id: 6,
    img: "/img/destinations/5/6.png",
    location: "Raykjavik",
    price: "29.52",
    delayAnimation: "600",
  },
];

export const destinations9 = [
  {
    id: 1,
    location: "New York",
    numberOfProperties: "4,090",
    delayAnimation: "0",
  },
  {
    id: 2,
    location: "London",
    numberOfProperties: "4,090",
    delayAnimation: "100",
  },
  {
    id: 3,
    location: "Los Angeles",
    numberOfProperties: "4,090",
    delayAnimation: "200",
  },
  {
    id: 4,
    location: "Paris",
    numberOfProperties: "4,090",
    delayAnimation: "300",
  },
  {
    id: 5,
    location: "Istanbul",
    numberOfProperties: "4,090",
    delayAnimation: "400",
  },
  {
    id: 6,
    location: "Rome",
    numberOfProperties: "4,090",
    delayAnimation: "500",
  },
  {
    id: 7,
    location: "Madrid",
    numberOfProperties: "4,090",
    delayAnimation: "600",
  },
];


export const destinations10 = [
  {
    id: 1,
    img: `${process.env.PUBLIC_URL}/photo1.jpg`,
    location: "Muscat",
    country: "Oman",
    numberOfProperties: "340",
    delayAnimation: "0",
  },
  {
    id: 2,
    img: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=85&fit=crop&crop=center",
    location: "Jebel Akhdar",
    country: "Oman",
    numberOfProperties: "82",
    delayAnimation: "100",
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?w=600&q=85&fit=crop&crop=center",
    location: "Wahiba Sands",
    country: "Oman",
    numberOfProperties: "56",
    delayAnimation: "200",
  },
  {
    id: 4,
    img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=85&fit=crop&crop=center",
    location: "Dubai",
    country: "UAE",
    numberOfProperties: "1,240",
    delayAnimation: "300",
  },
  {
    id: 5,
    img: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&q=85&fit=crop&crop=center",
    location: "Salalah",
    country: "Oman",
    numberOfProperties: "127",
    delayAnimation: "400",
  },
  {
    id: 6,
    img: "https://images.unsplash.com/photo-1549638441-b787d2e11f14?w=600&q=85&fit=crop&crop=center",
    location: "Maldives",
    country: "Indian Ocean",
    numberOfProperties: "210",
    delayAnimation: "500",
  },
  {
    id: 7,
    img: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=600&q=85&fit=crop&crop=center",
    location: "Istanbul",
    country: "Turkey",
    numberOfProperties: "890",
    delayAnimation: "600",
  },
  {
    id: 8,
    img: "https://images.unsplash.com/photo-1551632811-561732d1e306?w=600&q=85&fit=crop&crop=center",
    location: "Musandam",
    country: "Oman",
    numberOfProperties: "38",
    delayAnimation: "700",
  },
  {
    id: 9,
    img: "https://images.unsplash.com/photo-1548247416-ec66f4900b2e?w=600&q=85&fit=crop&crop=center",
    location: "Petra",
    country: "Jordan",
    numberOfProperties: "145",
    delayAnimation: "800",
  },
  {
    id: 10,
    img: "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=600&q=85&fit=crop&crop=center",
    location: "Abu Dhabi",
    country: "UAE",
    numberOfProperties: "420",
    delayAnimation: "900",
  },
];